import React from 'react';
import { Snackbar, Alert } from '@mui/material';
import type { SxProps } from '@mui/material';
import { useAppTheme } from '../hooks/useAppTheme';
import type { ThemedSxStyle } from '../types/themedStyles';

interface NotificationSnackbarProps {
  open: boolean;
  message: string;
  severity: 'success' | 'error' | 'info' | 'warning';
  onClose: () => void;
  autoHideDuration?: number;
  sx?: SxProps;
}

const NotificationSnackbar: React.FC<NotificationSnackbarProps> = ({
  open,
  message,
  severity,
  onClose,
  autoHideDuration = 6000,
  sx,
}) => {
  const { themed } = useAppTheme();

  return (
    <Snackbar 
      open={open} 
      autoHideDuration={autoHideDuration} 
      onClose={onClose}
      sx={sx}
    >
      <Alert 
        onClose={onClose} 
        severity={severity}
        sx={themed($alert)}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

const $alert: ThemedSxStyle = ({ colors }) => ({
  width: '100%',
  backgroundColor: colors.palette.input.background,
  color: colors.text,
  border: `1px solid ${colors.palette.border}`,
  transition: 'background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease'
});

export default NotificationSnackbar; 